import { render, staticRenderFns } from "./transportationInfo.vue?vue&type=template&id=e2211fc2&"
import script from "./transportationInfo.vue?vue&type=script&lang=js&"
export * from "./transportationInfo.vue?vue&type=script&lang=js&"
import style0 from "./transportationInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports